import { createSlice, PayloadAction } from "@reduxjs/toolkit"

interface GroqVoiceToTextInitialStates {
  isClient: boolean
  isGroqRecording: boolean
  isGroqTranscribing: boolean
}

const initialState: GroqVoiceToTextInitialStates = {
  isClient: false,
  isGroqRecording: false,
  isGroqTranscribing: false,
}

const GroqVoiceToText = createSlice({
  name: "groq-voice-to-text",
  initialState,
  reducers: {
    setIsClient: (state, action: PayloadAction<boolean>) => {
      state.isClient = action.payload
    },
    setIsGroqRecording: (state, action: PayloadAction<boolean>) => {
      state.isGroqRecording = action.payload
    },
    setIsGroqTranscribing: (state, action: PayloadAction<boolean>) => {
      state.isGroqTranscribing = action.payload
    },
  },
})

export const { setIsClient, setIsGroqRecording, setIsGroqTranscribing } = GroqVoiceToText.actions
export default GroqVoiceToText.reducer
